export default __webpack_public_path__ + "static/media/The Conviction of Will.fb8e2763.jpg";